import miniaLighthouse from "../assets/images/Miniatures/Minia-lighthouse.png";
import miniaIronLung from "../assets/images/Miniatures/Minia-iron-lung.png";
import miniaLunacid from "../assets/images/Miniatures/Minia-lunacid.png";
import miniaPetscop from "../assets/images/Miniatures/Minia-petscop.png";
//import miniaValleVerde from "../assets/images/Miniatures/Minia-valle-verde.png";

const inspiData = [
    { image: miniaLighthouse },
    { image: miniaIronLung },
    { image: miniaLunacid },
    { image: miniaPetscop },
    //{ image: miniaValleVerde }

];

export default inspiData;